import { __decorate } from "tslib";
import { NgModule } from 'angular-ts-decorators';
import { RandomStaffMemberComponent } from './random-staff-member/random-staff-member.component';
import { StaffMembersComponent } from './staff-members/staff-members.component';
import { StaffService } from './services/staff.service';
var StaffModule = (function () {
    function StaffModule() {
    }
    StaffModule = __decorate([
        NgModule({
            declarations: [RandomStaffMemberComponent, StaffMembersComponent],
            id: 'gn.audio.support.staff',
            imports: [],
            providers: [StaffService],
        })
    ], StaffModule);
    return StaffModule;
}());
export { StaffModule };
